import React from 'react';
import { Box, Divider, Grid, Stack } from '@mantine/core';
import { useDashboard } from '../hooks/useDashboard';
import { StatsGrid } from '../components/common/Stats';
import { DashboardHeader, SectionTitle } from '../components/Dashboard/DashboardLayout';
import { OperationsFeed } from '../components/Dashboard/OperationsFeed';
import ConfirmRollback from '../components/Dashboard/ConfirmRollback';
import { DashboardCharts } from '../components/Dashboard/DashboardCharts';
import { useDashboardStore } from '../store/useDashboardStore';

const Dashboard = () => {
  const {
    customerStats,
    financialStats,
    records,
    renovation,
    rollbackData,
    openRollBack,
    sendingEmail,
    toggleRollback,
    closeRollback,
    rollBackRenovation,
    sendEmailReport
  } = useDashboard();

  const { itemsPostpago, itemsPrepago, totalPostpago, totalPrepago } = useDashboardStore();

  return (
    <Box className="w-full px-2 pb-xl">
      <DashboardHeader onSendReport={sendEmailReport} loading={sendingEmail} />

      <Stack gap="xl">
        <Box>
          <SectionTitle title="Estado de Red y Clientes" />
          <StatsGrid data={customerStats} />
        </Box>

        <Box>
          <SectionTitle title="Resumen Financiero del Mes" />
          <StatsGrid data={financialStats} />
        </Box>

        <Box px="md">
          <SectionTitle title="Análisis de Cartera y Rendimiento" />
          <DashboardCharts data={{ itemsPostpago, itemsPrepago, totalPostpago, totalPrepago }} />
        </Box>

        <Divider my="sm" variant="dashed" />

        <Box px="md">
          <SectionTitle title="Actividad y Operaciones Recientes" />
          <OperationsFeed 
            records={records} 
            renovations={renovation} 
            onToggleRollback={toggleRollback} 
          />
        </Box>
      </Stack>

      <ConfirmRollback 
        show={ openRollBack } 
        onHide={ closeRollback } 
        item={ rollbackData } 
        onConfirm={ rollBackRenovation } 
      />
    </Box>
  );
};

export default Dashboard;
